module.exports = __webpack_public_path__ + "static/media/inicio.97b61e05.svg";